import React from 'react';
export var ContentLoadingErrorMessage = function ContentLoadingErrorMessage(_ref) {
  var isHidden = _ref.isHidden;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    React.createElement("p", {
      style: {
        display: isHidden ? 'none' : 'block'
      }
    }, "We couldn't load this content")
  );
};